import { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'

import { useAuth } from '../../../context/auth'

interface RedirectIfAuthProps {
  children: ReactNode
}

const RedirectIfAuth = ({ children }: RedirectIfAuthProps) => {
  const { state } = useAuth()

  if (state.isAuthenticated) {
    const from = localStorage.getItem('redirectAfterLogin')

    if (from && from !== '/orders') {
      return <Navigate to={from} state={from} replace />
    }

    return <Navigate to="/" replace />
  }

  return <>{children}</>
}

export default RedirectIfAuth
